import apiLessonHistory from '@/api/lesson-history';
import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import { GET_LESSON_HISTORY, GET_LESSON_HISTORY_SUCCESS } from '@/action-types/lesson-history';
import { ERROR_PASS_REQUEST, ERROR_UPDATE_REQUEST } from '@/action-types/error';
import { Action } from 'redux';

export function* getLessonHistory(params: { id?: number;}) {
  try {
    let userId = params.id;
    if (!params.id) userId = yield select((state) => state.student.data.id);

    const response = yield call(apiLessonHistory.getLessonHistory, userId);
    const responseData = (response?.data?.getLessonHistory ?? {});

    yield put({ type: GET_LESSON_HISTORY_SUCCESS, data: responseData });
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'getLessonHistory'] });
    yield put({ type: ERROR_UPDATE_REQUEST, isActive: true, errorData: e });
  }
}

export default function* lessonHistorySaga() {
  yield takeLatest<Action & { id?: number; }>(GET_LESSON_HISTORY, getLessonHistory);
}
